// Utility function for WhatsApp GTM tracking

import { trackWhatsAppClickConversion } from "./googleAdsTracking";

const DEFAULT_WHATSAPP_MESSAGE = "Hi, I want to book a  consultation";

export function createWhatsAppUrl(phoneNumber: string) {
  const normalizedPhoneNumber = phoneNumber.replace(/[^0-9]/g, "");
  const message = encodeURIComponent(DEFAULT_WHATSAPP_MESSAGE);

  return `https://wa.me/${normalizedPhoneNumber}?text=${message}`;
}

export function trackWhatsAppClick(buttonLocation: string) {
  if (typeof window !== "undefined") {
    // Type assertion for dataLayer (GTM initializes it via @next/third-parties)
    const win = window as unknown as {
      dataLayer?: Array<Record<string, unknown>>;
    };

    // Initialize dataLayer if it doesn't exist
    if (!win.dataLayer) {
      win.dataLayer = [];
    }

    // Push event to dataLayer
    const eventData = {
      event: "whatsapp_click",
      eventCategory: "Contact",
      eventAction: "WhatsApp Call Button Click",
      eventLabel: `WhatsApp Button - ${buttonLocation}`,
      buttonLocation: buttonLocation,
    };

    win.dataLayer.push(eventData);

    // Debug log (remove in production if needed)
    console.log("WhatsApp button clicked - GTM event pushed:", eventData);
  }

  trackWhatsAppClickConversion();
}

